import ButtonBack from '@components/buttons/button-back/button-back.component'
import onDefaultLayoutShowFooterChange from '@observables/default-layout-show-footer.observable'
import onDefaultLayoutShowHeaderChange from '@observables/default-layout-show-header.observable'
import React, { PropsWithChildren, useEffect } from 'react'
import { NavLink, BrowserRouter as Router } from 'react-router-dom'
import './navigation.layout.scoped.scss'
import './navigation.layout.scss'

export interface MenuItemNavigation {
  icon?: string
  label: string
  path?: string
  href?: string
  target?: string
  onClick?: () => any
  warning?: boolean
}

export interface PropsNavigation extends PropsWithChildren<React.HTMLAttributes<HTMLDivElement>> {
  title?: any
  header?: any
  footer?: any
  menu?: Array<MenuItemNavigation>
  isHome?: boolean
  backButton?: boolean
  onClickBackButton?: () => any
  onReferrerFalseUrlBackButton?: string
  asidePadding?: boolean
}

export default ({
  className = '',
  id = '',
  children,
  title = null,
  menu = [],
  header,
  footer,
  isHome = false,
  onClickBackButton,
  onReferrerFalseUrlBackButton = '/',
  backButton = false,
  asidePadding = true,
}: PropsNavigation) => {
  const wrapperAsideRef = React.useRef<HTMLDivElement>(null)
  const [height, setHeight] = React.useState(window?.innerHeight)
  const [width, setWidth] = React.useState(window?.innerWidth)

  // useEffect(() => {
  //   function onScrollAside(e) {
  //     wrapperAsideRef.current.style.top = `calc(${window.pageYOffset}px - 1rem)`
  //   }

  //   window.addEventListener('scroll', onScrollAside)
  //   return () => {
  //     window.removeEventListener('scroll', onScrollAside)
  //   }
  // }, [wrapperAsideRef])

  useEffect(() => {
    function handleResize() {
      if (isHome || window.innerWidth > 991) {
        onDefaultLayoutShowFooterChange.next(true)
        onDefaultLayoutShowHeaderChange.next(true)
      } else if (window.innerWidth < 992) {
        onDefaultLayoutShowHeaderChange.next(false)
        onDefaultLayoutShowFooterChange.next(false)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    const updateHeight = () => {
      setHeight(window?.innerHeight)
    }
    const updateWidth = () => {
      setWidth(window?.innerWidth)
    }
    window.addEventListener('resize', updateHeight)
    window.addEventListener('resize', updateWidth)
    return () => {
      onDefaultLayoutShowFooterChange.next(true)
      onDefaultLayoutShowHeaderChange.next(true)
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('resize', updateWidth)
      window.removeEventListener('resize', handleResize)
    }
  }, [isHome])

  return (
    <section className={`navigation scrollbar ${className} ${isHome ? 'is-home' : ''}`} id={id}>
      <Router basename="/">
        <aside>
          <div
            className="aside-wrapper scrollbar"
            ref={wrapperAsideRef}
            style={{
              height: width < 991 ? `calc(${height}px - 52px - 52px - 2rem)` : null,
            }}
          >
            <header style={{ padding: asidePadding ? '2rem 1rem 0' : 0 }}>
              {backButton ? (
                <ButtonBack
                  onClick={onClickBackButton}
                  circleLayout
                  className="top-back"
                  onReferrerFalseUrl={onReferrerFalseUrlBackButton}
                />
              ) : null}
              {typeof title === 'string' ? <h4>{title}</h4> : title}
              {header ? <div className="header-content">{header}</div> : null}
            </header>
            {menu?.length ? (
              <nav>
                <ul>
                  {menu?.map((item, key) => {
                    if (item.href) {
                      return (
                        <li key={key}>
                          <a href={item.href} target={item.target}>
                            {item.icon ? <i className={`fa-regular menu-icon fa-${item.icon}`}></i> : null}
                            <span>
                              {item.label}
                              {item?.warning ? <i className="fa-solid fa-diamond-exclamation warning-icon"></i> : null}
                            </span>
                            <i className="fa-regular chevron-right arrow-icon"></i>
                          </a>
                        </li>
                      )
                    }
                    if (item.path) {
                      return (
                        <li key={key}>
                          <NavLink
                            className={({ isActive }) => {
                              if (isActive) {
                                return 'active'
                              }
                              return ''
                            }}
                            to={item.path}
                          >
                            {item.icon ? (
                              <div>
                                <i className={`fa-regular menu-icon fa-${item.icon} common`}></i>
                                <i className={`fa-solid menu-icon fa-${item.icon} active`}></i>
                              </div>
                            ) : null}
                            <span>
                              {item.label}
                              {item?.warning ? <i className="fa-solid fa-diamond-exclamation warning-icon"></i> : null}
                            </span>
                            <i className="fa-regular fa-chevron-right arrow-icon"></i>
                          </NavLink>
                        </li>
                      )
                    }
                    if (item.onClick && typeof item.onClick === 'function') {
                      return (
                        <li key={key}>
                          <button
                            type="button"
                            onClick={(e) => {
                              e.preventDefault()
                              item.onClick()
                            }}
                            title={item.label}
                          >
                            {item.icon ? <i className={`fa-regular menu-icon fa-${item.icon}`}></i> : null}
                            <span>
                              {item.label}
                              {item?.warning ? <i className="fa-solid fa-diamond-exclamation warning-icon"></i> : null}
                            </span>
                            <i className="fa-regular chevron-right arrow-icon"></i>
                          </button>
                        </li>
                      )
                    }
                  })}
                </ul>
              </nav>
            ) : null}
            {footer ? <footer style={{ margin: '3rem 0 0', padding: asidePadding ? '0 1rem 2rem' : 0 }}>{footer}</footer> : null}
          </div>
        </aside>
        <div className="content">{children}</div>
      </Router>
    </section>
  )
}
